// exclude-from-index
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment-timezone';
import Grid from '../../Utility/Grid';
import DatePicker from '../../DatePicker';
import {
  StyledCollectionWrapper,
  StyledCardWrapper,
  StyledRoomInputWrapper,
  StyledBookingInfoWrapper,
  StyledRoomInput,
  StyledContainerHeading,
  StyledSpinner,
  StyledPaneContainerHeading
} from './Container.styles';

class Container extends Component {
  static propTypes = {
    /**
     * Children of the Collection should be Room Booking Card Components
     */
    children: PropTypes.node,
    /**
     * The Title for the Collection
     */
    title: PropTypes.string,
    /**
     * The dates of the datpicker
     */
    dates: PropTypes.shape({
      start: PropTypes.string,
      end: PropTypes.string
    }),
    /**
     * The total number of rooms
     */
    numRooms: PropTypes.number,
    /**
     * onChange for Room input
     */
    onChangeRooms: PropTypes.func,
    /**
     * The function to fire when the dates change
     */
    onChangeDates: PropTypes.func,

    /**
     * Labels used for localization within the collection
     */
    labels: PropTypes.shape({
      roomLabel: PropTypes.string
    }),

    loading: PropTypes.bool,
    propertyPane: PropTypes.bool
  };

  static defaultProps = {
    children: undefined,
    title: undefined,
    dates: undefined,
    numRooms: 0,
    labels: {
      roomLabel: undefined
    },
    onChangeRooms: () => {},
    onChangeDates: () => {},
    loading: false,
    propertyPane: false
  };

  constructor(props) {
    super(props);
    this.renderChildren = this.renderChildren.bind(this);
    this.setRooms = this.setRooms.bind(this);
    this.setDates = this.setDates.bind(this);
  }

  setRooms(event) {
    const { onChangeRooms, numRooms } = this.props;

    let value;

    try {
      value = parseInt(event.target.value, 10);
    } catch (e) {
      value = null;
    }

    if (value && numRooms !== value) {
      onChangeRooms(value);
    } else if (!value) {
      onChangeRooms(0);
    }
  }

  setDates(start, end) {
    const { onChangeDates } = this.props;
    onChangeDates(start.toString(), end.toString());
  }

  /* eslint-disable react/no-array-index-key */
  renderChildren() {
    const { children } = this.props;
    return React.Children.toArray(children).map((child, index) => (
      <StyledCardWrapper key={index}>{child}</StyledCardWrapper>
    ));
  }

  render() {
    const { title, numRooms, dates, onChangeDates, loading, propertyPane } = this.props;
    return (
      <StyledCollectionWrapper propertyPane={propertyPane}>
        {propertyPane ? (
          <StyledPaneContainerHeading>{title}</StyledPaneContainerHeading>
        ) : (
          <StyledContainerHeading>{title}</StyledContainerHeading>
        )}
        {loading && <StyledSpinner size={24} thickness={6} />}
        <StyledBookingInfoWrapper propertyPane={propertyPane}>
          {propertyPane ? null : (
            <Grid.ScreenClassRender
              render={screenClass => (
                <DatePicker
                  pickerPosition={['xl', 'lg'].includes(screenClass) ? 'right' : 'left'}
                  numberOfMonths={['xl', 'lg'].includes(screenClass) ? 2 : 1}
                  onDatesChangeHook={onChangeDates}
                  initialStartDate={dates.start}
                  initialEndDate={dates.end}
                  initialVisibleMonth={moment().add(0, 'months')}
                />
              )}
            />
          )}

          {propertyPane ? null : (
            <StyledRoomInputWrapper hasValue={numRooms !== ''} propertyPane={propertyPane}>
              <StyledRoomInput
                InputProps={{
                  type: 'number',
                  min: '0',
                  disableUnderline: true,
                  inputProps: { min: 0 }
                }}
                type="number"
                value={numRooms.toString()}
                label="Rooms"
                onChange={this.setRooms}
                propertyPane={propertyPane}
              />
            </StyledRoomInputWrapper>
          )}
        </StyledBookingInfoWrapper>
        {this.renderChildren()}
      </StyledCollectionWrapper>
    );
  }
}

export default Container;
